<script setup lang="ts">
    import { useRouter, useRoute } from 'vue-router';
    import type { SmsSent } from '../../interfaces';
    import { formatNumericText } from '@shared/utils/formatNumericText';

    const props = defineProps<{
        overview: SmsSent | null;
    }>();

    const router = useRouter();
    const route = useRoute();

    function navigateTo(contactType: string) {
        router.push({
            name: 'TextMessageStatisticsContacts',
            params: { smsMessageId: route.params.smsMessageId, contactType },
            query: { ...route.query },
        });
    }
</script>

<template>
    <div class="stat-highlights panel panel-default print-block">
        <div class="row no-gutter d-flex flex-wrap">
            <div class="flex-col col-md-3 col-sm-6 col-xs-12 col-print-3">
                <div class="stat-highlights-body ug-bars pointer" @click="navigateTo('Sent')">
                    <p class="bar-label">{{ $Resources.SmsSentLabel }}</p>
                    <p class="value">{{ formatNumericText(overview?.SentCount || 0, { largeNumbers: true }) }}</p>
                    <div class="bar">
                        <span class="bar-value bg-sent bar-transition" :style="{ width: overview?.SentPercentage + '%' }"></span>
                    </div>
                </div>
            </div>

            <div class="flex-col col-md-3 col-sm-6 col-xs-12 col-print-3">
                <div class="stat-highlights-body ug-bars pointer" @click="navigateTo('Delivered')">
                    <p class="bar-label">{{ $Resources.SmsReceivedPercentageLabel }}</p>
                    <p class="value">{{ formatNumericText(overview?.ReceivedPercentage || 0, { suffix: '%' }) }}</p>
                    <div class="bar">
                        <span class="bar-value bg-received bar-transition" :style="{ width: overview?.ReceivedPercentage + '%' }"></span>
                    </div>
                </div>
            </div>

            <div class="flex-col col-md-3 col-sm-6 col-xs-12 col-print-3">
                <div class="stat-highlights-body ug-bars pointer" @click="navigateTo('Clicked')">
                    <p class="bar-label">{{ $Resources.ClickedLabel }}</p>
                    <p class="value">{{ formatNumericText(overview?.ClickedPercentage || 0, { suffix: '%' }) }}</p>
                    <div class="bar">
                        <span class="bar-value bg-clicked bar-transition" :style="{ width: overview?.ClickedPercentage + '%' }"></span>
                    </div>
                </div>
            </div>

            <div class="flex-col col-md-3 col-sm-6 col-xs-12 col-print-3">
                <div class="stat-highlights-body ug-bars pointer" @click="navigateTo('Bounced')">
                    <p class="bar-label">{{ $Resources.SmsBouncedPercentageLabel }}</p>
                    <p class="value">{{ formatNumericText(overview?.BouncedPercentage || 0, { suffix: '%' }) }}</p>
                    <div class="bar">
                        <span class="bar-value bg-bounced bar-transition" :style="{ width: overview?.BouncedPercentage + '%' }"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
